module.exports = __webpack_public_path__ + "cecb0639aaea01321c2a512d55914213.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owls/honor-rays.png
// module id = 1734
// module chunks = 0